import { formValueSelector } from 'redux-form';

import { INFERENTIAL_STATISTICS } from '../../names';

const selector = formValueSelector(INFERENTIAL_STATISTICS);

const makeFieldValueGetter = field =>
  state => selector(state, field);

export const getObservedCountsDataSet =
  makeFieldValueGetter('chiSquare.observedCounts');

